import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImplementerCancelPage } from './implementer-cancel-page';
import { ImplementerCancelComponent } from '../implementer-cancel-component/implementer-cancel-component';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    ImplementerCancelPage,
    ImplementerCancelComponent,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ImplementerCancelPage),
  ],
})
export class ImplementerCancelPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-cancel/implementer-cancel/implementer-cancel-page.module.ts